{
  "endTime": "Godzina końcowa",
  "startTime": "Godzina początkowa",
  "time": "Godzina"
}
